export default __webpack_public_path__ + "static/media/algem-2.26c3979a.png";